import contactModule from './contactModule';
import careersHeader from './careersHeader';
import metaDetails from './metaDetails';

export default `
    ... on Careers {
        ${careersHeader}
        ${contactModule}
        ${metaDetails}
    }
`;
